// Sistema de logging configurable
const LOG_CONFIG = {
  sidebar: true,     // Logs del sidebar y navegación
  menu: true,        // Logs del menú dinámico
  module: true,      // Logs del ModuleSelector
  api: false,        // Logs de API
  auth: false,       // Logs de autenticación
  general: false,    // Logs generales
  errors: true       // Siempre mostrar errores
}

type LogCategory = keyof typeof LOG_CONFIG

export const logger = {
  log: (category: LogCategory, message: string, ...args: any[]) => {
    if (LOG_CONFIG[category]) {
      console.log(`[${category.toUpperCase()}]`, message, ...args)
    }
  },
  
  error: (category: LogCategory, message: string, ...args: any[]) => {
    if (LOG_CONFIG[category] || LOG_CONFIG.errors) {
      console.error(`[${category.toUpperCase()}]`, message, ...args)
    }
  },
  
  warn: (category: LogCategory, message: string, ...args: any[]) => {
    if (LOG_CONFIG[category]) {
      console.warn(`[${category.toUpperCase()}]`, message, ...args)
    }
  }
}